"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageTags_1 = require("../../core/messaging/MessageTags");
var OmnichannelMessage_1 = require("../../core/messaging/OmnichannelMessage");
var createChannelDataEgressMiddleware = function (channelData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var channelDataMiddleware = function () { return function (next) { return function (activity) {
        var applicable = activity && activity.channelData;
        if (applicable) {
            if (!activity.channelData.tags) {
                activity.channelData.tags = [];
            }
            if (!activity.channelData.tags.includes(MessageTags_1.channelIdTag)) {
                activity.channelData.tags.push(MessageTags_1.channelIdTag);
            }
            if (!activity.channelData.tags.includes(MessageTags_1.customerMessageTag)) {
                activity.channelData.tags.push(MessageTags_1.customerMessageTag);
            }
            if (!activity.channelData.metadata) {
                activity.channelData.metadata = {};
            }
            if (!activity.channelData.metadata.deliveryMode) {
                activity.channelData.metadata.deliveryMode = OmnichannelMessage_1.DeliveryMode.Bridged;
            }
            if (channelData.widgetId) {
                activity.channelData.metadata.widgetId = channelData.widgetId;
            }
        }
        return next(activity);
    }; }; };
    return channelDataMiddleware;
};
exports.default = createChannelDataEgressMiddleware;
//# sourceMappingURL=createChannelDataEgressMiddleware.js.map